import React from 'react';
import PropTypes from 'prop-types';
import SectionListItem from './SectionListItem';

import './SectionList.scss';

const SectionList = ({
  items,
  heading,
  lang = {
    sectionListAriaLabel: 'Våre seksjonsliste',
  },
}) => {
  return items && items.length > 0 ? (
    <nav className="section-list" aria-label={lang.sectionListAriaLabel}>
      <div className="section-list__container">
        {heading && <h2 className="section-list__heading">{heading}</h2>}
        <ul className="section-list__items">
          {items.map((item, index) => {
            return (
              <li className="section-list__item" key={index}>
                <SectionListItem {...item} headingTagLevel={heading ? 3 : 2} />
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  ) : null;
};

SectionList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.exact(SectionListItem.propTypes))
    .isRequired,
  heading: PropTypes.string,
  lang: PropTypes.shape({
    sectionListAriaLabel: PropTypes.string.isRequired,
  }).isRequired,
};

export default SectionList;
